import { render, staticRenderFns } from "./AddressPostalcode.vue?vue&type=template&id=4d36dab5&"
import script from "./AddressPostalcode.vue?vue&type=script&lang=ts&"
export * from "./AddressPostalcode.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports